import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { Workspace } from "../workspace";
import { useSelectedTab } from "../workspace/hooks/selected-tab";
import { useCategoryId } from "@/hooks/use-workbook";
import { cn } from "@/lib/utils";

interface WorkspaceLayoutProps {
  children: React.ReactNode;
}

export const WorkspaceLayout: React.FC<WorkspaceLayoutProps> = ({
  children,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const location = useLocation();

  const { data: categoryId } = useCategoryId();
  const { selectedTab } = useSelectedTab();

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      (e.target as HTMLElement).classList.add("jss_object");

      setTimeout(() => {
        (e.target as HTMLElement).classList.remove("jss_object");
      }, 100);
    };

    ref.current?.addEventListener("mousedown", handleClick, true);

    return () => {
      ref.current?.removeEventListener("mousedown", handleClick, true);
    };
  }, []);

  if (location.pathname === "/dsd-files") {
    return <div className="min-h-screen h-screen w-full">{children}</div>;
  }

  return (
    <div className="flex h-screen">
      <div className="flex-1 h-full overflow-scroll">
        <Workspace categoryId={categoryId} />
      </div>
      <div
        className={cn(
          "flex h-full min-w-[350px] overflow-auto justify-start bg-white z-30 border-l-[1px] shadow-lg",
          selectedTab === "XBRL" && "hidden",
        )}
        ref={ref}
      >
        {children}
      </div>
    </div>
  );
};
